import {
  withDatasourceCheck,
  Text,
  NextImage,
  TextField,
  Field,
  LinkField,
  ImageField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';

import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import Rating from 'components/includes/Rating';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type Fields = {
  title: TextField;
  stars: TextField;
  starsDescription: Field<string>;
  ctaLink: LinkField;
  items: Array<{ fields: { image: ImageField } }>;
};

type AwardsBannerProps = ComponentProps & {
  fields: Fields;
  rendering: object;
};

const AwardsBanner = ({ fields, rendering }: AwardsBannerProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor: boolean | undefined = sitecoreContext.pageEditing;
  const { anchorId, backgroundClass } = useHelpers(rendering);

  const images = fields.items;
  const starsDescription = {
    ...fields.starsDescription,
    value: fields.starsDescription?.value.replace(
      '{token.stars}',
      String(fields.stars.value ?? '0')
    ),
  };
  const gotStarsValue: boolean = !!fields?.stars?.value;
  const showStars: undefined | boolean = gotStarsValue || isExperienceEditor;

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`default-section-padding ${backgroundClass}`}
    >
      <div className="awards-banner container">
        <div className="row">
          <div
            className={`col-12 col-lg-4 d-flex flex-column flex-md-row flex-lg-column align-items-start justify-content-between ${
              !gotStarsValue ? 'justify-content-lg-center' : ''
            }`}
          >
            <div>
              <Text tag="p" field={fields.title} className="subheader-1 background-to-change" />
              {showStars && (
                <div className="d-flex flex-nowrap align-items-center mt-2">
                  <Rating rating={+(fields.stars.value ?? 0)} />
                  <Text
                    tag="p"
                    field={starsDescription}
                    className="stars-description background-to-change body-default"
                  />
                </div>
              )}
              <AbrdnButton
                buttonType="primary"
                linkField={fields.ctaLink}
                className="w-auto mt-6 mt-md-0 mt-lg-6"
              />
            </div>
          </div>
          <div className="col-12 col-lg-8 mt-6 mt-lg-0">
            <div className="images-wrapper d-flex flex-row flex-lg-row-reverse flex-wrap flex-lg-nowrap justify-content-start">
              {images.map((image, index) => (
                <div
                  key={index}
                  className="award-image background-white flex-shrink-0 d-flex align-items-center justify-content-center mt-md-0"
                >
                  <NextImage field={image.fields.image} width="200" height="110" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withDatasourceCheck()<AwardsBannerProps>(AwardsBanner);
